/**
 * Generated by orval 🍺
 * Do not edit manually.
 * MOTOLYNK MARKET API
 * Admin, vendor and store APIs of the MOTOLYNK multi-vendor marketplace.
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `refund` - Refund
 * * `replacement` - Replacement
 * * `exchange` - Exchange
 */
export type ResolutionEnum = typeof ResolutionEnum[keyof typeof ResolutionEnum];


export const ResolutionEnum = {
  refund: 'refund',
  replacement: 'replacement',
  exchange: 'exchange',
} as const;
